var render = function render(_c,_vm){return _c('div',[_c('p',[_vm._v(" Le credenziali sono state salvate correttamente. E' ora possibile inviare i documenti di spesa al Servizio Tessera Sanitaria. ")]),_c('p',[_vm._v("A breve si verrà reindirizzati alla pagina home.")]),_c('router-link',{attrs:{"to":"/","tag":"button"}},[_vm._v("Torna alla home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }